import React from 'react'
import StyledButton from './Button'
import { ButtonProps as MUIButtonProps, CircularProgress } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  spinner: {
    marginLeft: 4,
    width: '12px !important',
    height: '12px !important',
    color: '#b7b7b7'
  }
}))

interface ButtonProps extends MUIButtonProps {
  saving?: boolean
  invert?: string
}

const Button: React.FC<ButtonProps> = ({
  saving,
  disabled,
  children,
  ...rest
}) => {
  const classes = useStyles()
  return (
    <StyledButton disabled={saving || disabled} {...rest}>
      {children}
      {saving && <CircularProgress className={classes.spinner} />}
    </StyledButton>
  )
}

export default Button
